import { render, staticRenderFns } from "./RelatedLoadsList.vue?vue&type=template&id=6fb4c918&"
import script from "./RelatedLoadsList.vue?vue&type=script&lang=js&"
export * from "./RelatedLoadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports